import { Checkbox, Divider, Stack, Switch, Text, useMediaQuery } from '@chakra-ui/react'
import { validateCheckboxBrand, validateCheckboxVolume, validateCheckboxMaterial, validateCheckboxReturnability } from '../utils/functionsValidateProduct'

const FilterCheckbox = ({ productsApi, Checked, setChecked }) => {
  const [isLargerThan768] = useMediaQuery('(max-width: 780px)')

  const handleChecked = (e) => {
    const { value } = e.target
    const newChecked = [...Checked]
    const index = newChecked.indexOf(value)

    if (index === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(index, 1)
    }

    setChecked(newChecked)
  }

  return (
    <>
      {!isLargerThan768
        ? <>
          <Text
            color={'#0A0808'}
            fontSize={'16px'}
            fontWeight={'700'}
            marginBottom={'1rem'}
          >
            Marca
          </Text>
          <Stack direction='column' spacing={5}>
            {productsApi.filter((product, index, self) => {
              return index === self.findIndex((t) => (
                t.brand.description === product.brand.description
              ))
            }).sort((a, b) => a.brand.description.toLowerCase() < b.brand.description.toLowerCase() ? -1 : 1).map((item) => (
              <Checkbox
                {...Checked.includes(item.brand.description) ? { isChecked: true } : { isChecked: false }}
                {...validateCheckboxBrand(Checked) &&
                  !Checked.includes(item.brand.description)
                  ? { isDisabled: true }
                  : { isDisabled: false }}
                key={item.brand.brandId}
                name='volume'
                value={item.brand.description}
                onChange={handleChecked}
              >{item.brand.description}</Checkbox>
            ))}
          </Stack>

          <Divider borderColor={'#E1E1E1'} marginTop={4} />

          <Text
            color={'#0A0808'}
            fontSize={'16px'}
            fontWeight={'700'}
            marginBottom={'1rem'}
            marginTop={'1rem'}
          >
            Litros
          </Text>

          <Stack direction='column' spacing={5}>
            {productsApi.filter((product, index, self) => {
              return index === self.findIndex((t) => (
                t.volume.description === product.volume.description
              ))
            }).sort((a, b) => a.volume.description.toLowerCase() < b.volume.description.toLowerCase() ? -1 : 1).map((item) => (
              <Checkbox
                {...Checked.includes(item.volume.description) ? { isChecked: true } : { isChecked: false }}
                // si selecciono 1,5L deshabilita los demas
                {...validateCheckboxVolume(Checked) &&
                !Checked.includes(item.volume.description)
                  ? { isDisabled: true }
                  : { isDisabled: false }}
                key={item.volume.volumeId}
                name='volume'
                value={item.volume.description}
                onChange={handleChecked}
              >{item.volume.description}</Checkbox>
            ))}
          </Stack>

          <Divider borderColor={'#E1E1E1'} marginTop={4} />

          <Text
            color={'#0A0808'}
            fontSize={'16px'}
            fontWeight={'700'}
            marginBottom={'1rem'}
            marginTop={'1rem'}
          >
            Material
          </Text>
          <Stack direction='column' spacing={5}>
            {productsApi.filter((product, index, self) => {
              return index === self.findIndex((t) => (
                t.material.description === product.material.description
              ))
            }).sort((a, b) => a.material.description.toLowerCase() < b.material.description.toLowerCase() ? -1 : 1).map((item) => (
              <Checkbox
                {...Checked.includes(item.material.description) ? { isChecked: true } : { isChecked: false }}
                {...validateCheckboxMaterial(Checked) &&
                  !Checked.includes(item.material.description)
                  ? { isDisabled: true }
                  : { isDisabled: false }}
                key={item.material.materialId}
                name='material'
                value={item.material.description}
                onChange={handleChecked}
              > {item.material.description}</Checkbox>
            ))}
          </Stack>

          <Divider borderColor={'#E1E1E1'} marginTop={4} />

          <Text
            color={'#0A0808'}
            fontSize={'16px'}
            fontWeight={'700'}
            marginBottom={'1rem'}
            marginTop={'1rem'}
          >
            Envase
          </Text>
          <Stack direction='column' spacing={5}>
            {productsApi.filter((product, index, self) => {
              return index === self.findIndex((t) => (
                t.returnability.description === product.returnability.description
              ))
            }).sort((a, b) => a.returnability.description.toLowerCase() < b.returnability.description.toLowerCase() ? -1 : 1).map((item) => (
              <Checkbox
                {...Checked.includes(item.returnability.description) ? { isChecked: true } : { isChecked: false }}
                {...validateCheckboxReturnability(Checked) &&
                  !Checked.includes(item.returnability.description)
                  ? { isDisabled: true }
                  : { isDisabled: false }}
                key={item.returnability.returnabilityId}
                name='returnability'
                value={item.returnability.description}
                onChange={handleChecked}
              > {item.returnability.description}</Checkbox>

            ))}

          </Stack>
        </>
        : null }
    </>
  )
}

export default FilterCheckbox
